import './init'
import Purge from './pages/Purge'
import PurgeHistory from './pages/PurgeHistory'
import i18n from 'live/services/i18n'
import ExtensionService from 'live/services/extension'
import SettingsService from 'live/services/settings'
import purgeSettings from './settings/purgeSettings'
import ServiceLocator from 'live/services/service-locator'
import PurgeExtraActionsRegistry from './services/purge-extra-actions-registry'

const purgeConfig = {
    name: i18n('Purge'),
    url: '#/plugin-purge/rules',
    alias: 'plugin-purge-rules',
    ico: 'fas fa-trash',
    position: 'first-block',
    addRoute: true,
    routeUrl: 'plugin-purge/rules',
    component: Purge
}

const purgeHistoryConfig = {
    name: i18n('Purge History'),
    url: '#/plugin-purge/history',
    alias: 'plugin-purge-history',
    ico: 'fas fa-history',
    position: 'first-block',
    addRoute: true,
    routeUrl: 'plugin-purge/history',
    component: PurgeHistory
}

ExtensionService.addAdminMenu(purgeConfig)
ExtensionService.addAdminMenu(purgeHistoryConfig)
Live.settings.hidePurgeMenu = true
SettingsService.register(purgeSettings)
ServiceLocator.registerService('purge-extra-actions-registry', PurgeExtraActionsRegistry)
